"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "en_US", {
  enumerable: true,
  get: function get() {
    return _en_us.default;
  }
});
Object.defineProperty(exports, "ko_KR", {
  enumerable: true,
  get: function get() {
    return _ko_kr.default;
  }
});
Object.defineProperty(exports, "zh_TW", {
  enumerable: true,
  get: function get() {
    return _zh_tw.default;
  }
});
Object.defineProperty(exports, "zh_CN", {
  enumerable: true,
  get: function get() {
    return _zh_cn.default;
  }
});
Object.defineProperty(exports, "pt_BR", {
  enumerable: true,
  get: function get() {
    return _pt_br.default;
  }
});
Object.defineProperty(exports, "it_IT", {
  enumerable: true,
  get: function get() {
    return _it_it.default;
  }
});
Object.defineProperty(exports, "es_ES", {
  enumerable: true,
  get: function get() {
    return _es_es.default;
  }
});
Object.defineProperty(exports, "ja_JP", {
  enumerable: true,
  get: function get() {
    return _ja_jp.default;
  }
});
Object.defineProperty(exports, "de_DE", {
  enumerable: true,
  get: function get() {
    return _de_de.default;
  }
});
Object.defineProperty(exports, "fr_FR", {
  enumerable: true,
  get: function get() {
    return _fr_fr.default;
  }
});

var _en_us = _interopRequireDefault(require("./en_us.json"));

var _ko_kr = _interopRequireDefault(require("./ko_kr.json"));

var _zh_tw = _interopRequireDefault(require("./zh_tw.json"));

var _zh_cn = _interopRequireDefault(require("./zh_cn.json"));

var _pt_br = _interopRequireDefault(require("./pt_br.json"));

var _it_it = _interopRequireDefault(require("./it_it.json"));

var _es_es = _interopRequireDefault(require("./es_es.json"));

var _ja_jp = _interopRequireDefault(require("./ja_jp.json"));

var _de_de = _interopRequireDefault(require("./de_de.json"));

var _fr_fr = _interopRequireDefault(require("./fr_fr.json"));